import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { Box, Button, Typography, useMediaQuery, useTheme, } from "@mui/material";
import { centered } from "@ui/style/style";
import { ArrowRight } from "iconsax-react";
import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import i18n from "../../../../i18n";
import { GetExternalCountPerCompanyAsync } from "@application/features/external/externalThunk";
export const SuccessMsg = ({ eventType, onClick }) => {
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const isBelow1024 = useMediaQuery(theme.breakpoints.down(1025)); // to trigger responsiveness on 1024px
    const isBelow390 = useMediaQuery(theme.breakpoints.down(391)); // to trigger responsiveness on 391px
    const isOnly1152 = useMediaQuery(theme.breakpoints.between(1152, 1153)); // macbook only
    const { externalCountData } = useAppSelector((state) => state.external);
    const { personalInfo } = useAppSelector((state) => state.person);
    const { singleEvent } = useAppSelector((state) => state.event);
    const { t } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
        if (personalInfo?.id) {
            dispatch(GetExternalCountPerCompanyAsync(personalInfo?.id));
        }
    }, [dispatch, personalInfo?.id]);
    function formatDateToDayDateMonth(dateStr) {
        const locale = i18n.language === "nl" ? "nl" : "en-gb";
        return moment(dateStr).locale(locale).format("dddd D MMMM");
    }
    return (_jsx(Box, { sx: {
            px: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
        }, children: _jsxs(Box, { sx: {
                ...centered,
                flexDirection: "column",
            }, children: [_jsx(Box, { component: "img", src: eventType && eventType === "family"
                        ? "/assets/images/swd.png"
                        : "/assets/images/relations-day-logo.svg", sx: {
                        width: "auto",
                        height: `min(${isBelow390 ? 188 : isBelow1024 ? 144 : 200}px, 26.5dvh)`,
                    }, alt: "feature image" }), _jsx(Typography, { fontSize: { xs: 22, sm: 24, lg: 40 }, mt: 2, textAlign: "center", fontFamily: "Formula1", fontWeight: 500, lineHeight: "100%", color: "#FFFFFF", textTransform: "uppercase", children: eventType && eventType === "family"
                        ? t("event.registrationconfirmed.family")
                        : t("event.registrationconfirmed.directors") }), _jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #00244D33",
                        borderRadius: 2,
                        width: "100%",
                        maxWidth: 589,
                        padding: 3,
                        mt: 3,
                        gap: 3,
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0px 40px 56px 0px #00000014,  0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A",
                    }, children: [eventType && eventType === "family" && (_jsxs(Typography, { variant: "subtitle1", fontWeight: 400, color: "#00244D", children: [t("common.dear"), " ", `${personalInfo?.firstName} ${personalInfo?.middleName} ${personalInfo?.lastName}`, ","] })), _jsx(Typography, { variant: "subtitle1", fontWeight: 400, color: "#00244D", children: _jsx(Trans, { i18nKey: eventType && eventType === "family"
                                    ? t("event.registrationconfirmedText.family")
                                    : eventType === "directors"
                                        ? t("event.registrationconfirmedText.directors", {
                                            perCompanyDaySlotCount: externalCountData?.perDaySlotCount,
                                        })
                                        : t("event.registrationconfirmedText.externals"), components: {
                                    bold: _jsx("span", { style: { fontWeight: 500 } }),
                                    br: _jsx("br", {}),
                                }, values: {
                                    date: formatDateToDayDateMonth(singleEvent?.eventDates?.[0]?.date || ""),
                                } }) }), eventType !== "directors" && (_jsx(Typography, { variant: "subtitle1", fontWeight: 400, color: "#00244D", children: t("event.seeYou") })), eventType === "directors" && (_jsx(Button, { onClick: onClick, fullWidth: true, variant: "contained", endIcon: _jsx(ArrowRight, { size: "16px" }), sx: { mt: 1, fontWeight: 500 }, color: "ePrimary", children: t("event.addExternals") }))] })] }) }));
};
